export const SET_VIEW_MODE = "APPLICATION/SET_VIEW_MODE";
